"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValetService = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Api = _interopRequireDefault(require("../Api"));
var _excluded = ["token", "id"],
  _excluded2 = ["token"],
  _excluded3 = ["token", "id"],
  _excluded4 = ["token"],
  _excluded5 = ["token"],
  _excluded6 = ["token", "tenantId"],
  _excluded7 = ["token", "tenantId"],
  _excluded8 = ["token", "tenantId"],
  _excluded9 = ["token", "tenantId"],
  _excluded10 = ["token", "tenantId", "id"],
  _excluded11 = ["token", "tenantId", "id"],
  _excluded12 = ["token", "tenantId"],
  _excluded13 = ["token", "tenantId"],
  _excluded14 = ["token", "tenantId"],
  _excluded15 = ["token", "tenantId", "id"],
  _excluded16 = ["token", "tenantId", "id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ValetService = exports.ValetService = /*#__PURE__*/(0, _createClass2["default"])(function ValetService() {
  (0, _classCallCheck2["default"])(this, ValetService);
});
(0, _defineProperty2["default"])(ValetService, "getValetById", function (_ref) {
  var token = _ref.token,
    id = _ref.id,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return _Api["default"].withAuth(token).get("/valetParking/".concat(id), {
    params: params
  });
});
(0, _defineProperty2["default"])(ValetService, "listValets", function (_ref2) {
  var token = _ref2.token,
    params = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return _Api["default"].withAuth(token).get('/valetParking', {
    params: params
  });
});
(0, _defineProperty2["default"])(ValetService, "editValetParking", function (_ref3) {
  var token = _ref3.token,
    id = _ref3.id,
    params = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
  return _Api["default"].withAuth(token).patch("/valetParking/".concat(id), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(ValetService, "valetUsageByPeriods", function (_ref4) {
  var token = _ref4.token,
    params = (0, _objectWithoutProperties2["default"])(_ref4, _excluded4);
  return _Api["default"].withAuth(token).get('/dashboard/valet/usageByPeriods', {
    params: params
  });
});
(0, _defineProperty2["default"])(ValetService, "valetMovementByDay", function (_ref5) {
  var token = _ref5.token,
    params = (0, _objectWithoutProperties2["default"])(_ref5, _excluded5);
  return _Api["default"].withAuth(token).get('/dashboard/valet/movementByDay', {
    params: params
  });
});
(0, _defineProperty2["default"])(ValetService, "valetCustomersReport", function (_ref6) {
  var token = _ref6.token,
    tenantId = _ref6.tenantId,
    params = (0, _objectWithoutProperties2["default"])(_ref6, _excluded6);
  return _Api["default"].withAuth(token, tenantId).get('/management/valetParking/paymentReport', {
    params: params
  });
});
(0, _defineProperty2["default"])(ValetService, "listCustomerReportsPaymentoMethodFilters", function (_ref7) {
  var token = _ref7.token,
    tenantId = _ref7.tenantId,
    params = (0, _objectWithoutProperties2["default"])(_ref7, _excluded7);
  return _Api["default"].withAuth(token, tenantId).get("/management/valetParking/paymentMethods", {
    params: params
  });
});
(0, _defineProperty2["default"])(ValetService, "listCustomerReportsSortByFilters", function (_ref8) {
  var token = _ref8.token,
    tenantId = _ref8.tenantId,
    params = (0, _objectWithoutProperties2["default"])(_ref8, _excluded8);
  return _Api["default"].withAuth(token, tenantId).get("/management/valetParking/sortFields", {
    params: params
  });
});
(0, _defineProperty2["default"])(ValetService, "valetAbility", function (_ref9) {
  var token = _ref9.token,
    tenantId = _ref9.tenantId,
    params = (0, _objectWithoutProperties2["default"])(_ref9, _excluded9);
  return _Api["default"].withAuth(token, tenantId).get("/staff/valetParking/ability", {
    params: params
  });
});
(0, _defineProperty2["default"])(ValetService, "currentValetFee", function (_ref10) {
  var token = _ref10.token,
    tenantId = _ref10.tenantId,
    id = _ref10.id,
    params = (0, _objectWithoutProperties2["default"])(_ref10, _excluded10);
  return _Api["default"].withAuth(token, tenantId).post("/staff/valetParking/".concat(id, "/calcPrice"), {
    params: params
  });
});
(0, _defineProperty2["default"])(ValetService, "valetAllowCheckout", function (_ref11) {
  var token = _ref11.token,
    tenantId = _ref11.tenantId,
    id = _ref11.id,
    params = (0, _objectWithoutProperties2["default"])(_ref11, _excluded11);
  return _Api["default"].withAuth(token, tenantId).post("/management/valetParking/".concat(id, "/allowCheckout"), {
    params: params
  });
});
(0, _defineProperty2["default"])(ValetService, "valetPaymentSummary", function (_ref12) {
  var token = _ref12.token,
    tenantId = _ref12.tenantId,
    params = (0, _objectWithoutProperties2["default"])(_ref12, _excluded12);
  return _Api["default"].withAuth(token, tenantId).get("/management/valetParking/paymentSummary", {
    params: params
  });
});
(0, _defineProperty2["default"])(ValetService, "exportCustomersReportPDF", function (_ref13) {
  var token = _ref13.token,
    tenantId = _ref13.tenantId,
    params = (0, _objectWithoutProperties2["default"])(_ref13, _excluded13);
  return _Api["default"].withAuth(token, tenantId).get("/management/valetParking/getPdfReport", {
    params: params
  });
});
(0, _defineProperty2["default"])(ValetService, "exportCustomersReportCSV", function (_ref14) {
  var token = _ref14.token,
    tenantId = _ref14.tenantId,
    params = (0, _objectWithoutProperties2["default"])(_ref14, _excluded14);
  return _Api["default"].withAuth(token, tenantId).get("/management/valetParking/getCsvReport", {
    params: params
  });
});
(0, _defineProperty2["default"])(ValetService, "changeValetFee", function (_ref15) {
  var token = _ref15.token,
    tenantId = _ref15.tenantId,
    id = _ref15.id,
    params = (0, _objectWithoutProperties2["default"])(_ref15, _excluded15);
  return _Api["default"].withAuth(token, tenantId).post("/management/valetParking/".concat(id, "/calculationMethod"), params);
});
(0, _defineProperty2["default"])(ValetService, "currentPriceTableFee", function (_ref16) {
  var token = _ref16.token,
    tenantId = _ref16.tenantId,
    id = _ref16.id,
    params = (0, _objectWithoutProperties2["default"])(_ref16, _excluded16);
  return _Api["default"].withAuth(token, tenantId).post("/staff/valetParking/".concat(id, "/calcPrice"), params);
});